import React from 'react';
import { useTranslation } from 'react-i18next';
import packageJson from '../../../package.json'; // Adjust path as necessary

const AppInfoView = () => {
    const { t } = useTranslation();
    const version = packageJson.version;

    return (
        <div className="bg-black/20 backdrop-blur-md rounded-2xl p-6 border border-slate-700/50 text-center">
            <h2 className="text-4xl font-bold font-playfair mb-2 text-blue-300">Whispers of Harmony</h2>
            <p className="text-lg text-gray-400 mb-4">{t('settings.about.version')} {version}</p>
            <p className="text-gray-300 max-w-prose mx-auto">{t('settings.about.appDescription')}</p>
            
            <div className="mt-6 text-sm text-gray-500">
                <p>&copy; {new Date().getFullYear()} Health & Legend LLC. {t('settings.about.allRightsReserved')}</p>
            </div>
        </div>
    );
};

export default AppInfoView;